<template>
  <div>
    <div class="flex mt-8 gap-3">
      <transaction-table :payments="payments" @download_csv="downloadCSV"/>
      <transaction-graph :payments="payments" :selectedFilters="selectedFilters" :selectedDateCustom="selectedDateCustom"/>
    </div>
  </div>
</template>

<script>
import TransactionTable from './TransactionTable.vue';
import TransactionGraph from './TransactionGraph.vue';
export default {
  components: {
    TransactionTable,
    TransactionGraph,
  },
  props: {
    payments: {
      type: Array,
      required: true,
    },
    selectedFilters:{
       type: String 
    },
    selectedDateCustom:{
      type:Array,
    }
  },
  methods:{
    downloadCSV(value){
      console.log("transaction Sheet",value);
      if(value==true)
      this.$emit('download_csv',true)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>